// Librerias
import React from 'react'
let PropTypes = React.PropTypes

export class InputOkCliente extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            valor: this.props.inventario.inv_aprobacionCliente,
            facturado: this.props.inventario.inv_facturado
        }
        this.cambioCheckbox = (evt)=>{
            let estado = evt.target.checked
            this.finalizarEdicion(estado)
            evt.preventDefault()
            this.setState({
                valor: estado
            })
        }
        this.finalizarEdicion = (estado)=>{
            this.props.aprobacionCliente(this.props.inventario.inv_idInventario, estado)
        }
    }
    render(){
        return (
            <input
                type="checkbox"
                checked={this.state.valor}
                onChange={this.cambioCheckbox.bind(this)}
                disabled={this.state.facturado}
            />
        )
    }
}
InputOkCliente.propTypes = {
    inventario: PropTypes.object
}


// WEBPACK FOOTER //
// ./frontEnd/inventarios/diferencias-inventarios/InputOkCliente.jsx